export default "__VITE_ASSET__ChvIQQD7__"